import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PropertyData, BObjectModel, QueovalItemModel, HtmlBase, CompteSurEntite } from '../../../../models';
import { CoreService } from '../../../../services/core.service';
import { HttpService } from '../../../../services/dataAccess.service';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-numering',
  templateUrl: './numering.component.html',
  styleUrls: ['./numering.component.css', '../../dynamictag.component.css']
})

export class NumeringComponent extends BaseAddOnComponent {

  public modalLoading: boolean = false;
  public entites: Array<CompteSurEntite> = new Array<CompteSurEntite>();
  @Input('input') item: PropertyData;
  @Input('model') model: BObjectModel;

  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);
  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal
  ) { super(); }

  public OnButtonClicked(button: HtmlBase, content: any): void {
    switch (button.TypeModal) {
      case 'MODAL':
        this.modalLoading = true;
        this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/CLIENT_ENTITE/${button.Value}`).subscribe(
          (result: QueovalItemModel) => {
            this.entites = result.CompteSurEntite;
            this.modalLoading = false;
          });
        this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-bo-compte-client-sur-entite qmodalover' }).result.then((modalResult) => {
          switch (modalResult) {
            //  case 'SAVE': this.saveConfigSignature(); break;
            //  case 'CANCEL': this.closeConfigSignature(); break;
          }
        });
        break;
      case 'NUMERING':
        //this.http.getHttp<QueovalItemModel>(`${this.indParam.ConfigFile.apiUrl}${url}/${value}|${this.identBo}`).subscribe(
        this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}${button.OnClick}/${button.Value}|${this.model.IdDonneeFils}`).subscribe(
          (result: QueovalItemModel) => {
            this.item.MainElementList[0].Value = result.queovalItemList[0].Value.toString();
          }
        );
        break;
      default:
        this.navig.emit(button);
    }
  }

  public Save(modal: any): void {
    const model: QueovalItemModel = new QueovalItemModel();
    model.Mode = 'UPDATE_COMPTE_CLIENT';
    model.CompteSurEntite = this.entites;
    model.Ident = this.model.IdDonneeFils;
    this.modalLoading = true;
    this.http.postHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/`, model).subscribe(
      (result: QueovalItemModel) => {
        this.modalLoading = false;
        modal.close('SAVE');
      });
  }

  public getId(item: PropertyData): string {
    return item.MainElementList && item.MainElementList.length > 0 ? item.MainElementList[0].ID : '';
  }
  public setClass(item: PropertyData, index: number = 0): string {
    if (item.MainElementList[index].Required) {
      //alert(item.MainElementList[index].InValid);
      const t: boolean | undefined = item.MainElementList[index].InValid;
    }
    if (item.MainElementList[index].Disabled)
      return 'q-bo-disabled';
    if (item.MainElementList[index].InValid)
      return 'q-bo-novalid';
    if (item.MainElementList[index].Required)
      return 'q-bo-required';
    return '';
  }
  public isDisabled(item: PropertyData): boolean {
    //////return (this.view && this.view === 'read') ? true : item.MainElementList[0].Disabled;
    return item.MainElementList[0].Disabled;
  }
}


